export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

function fileKey(file: File): string {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

export function mergeAttachmentFiles(
  currentFiles: File[],
  incomingFiles: File[],
): { files: File[]; error: string | null } {
  const deduped = new Map<string, File>();
  for (const file of currentFiles) {
    deduped.set(fileKey(file), file);
  }

  for (const file of incomingFiles) {
    if (file.size <= 0) {
      return { files: currentFiles, error: `${file.name || "file"} is empty` };
    }

    if (file.size > MAX_ATTACHMENT_BYTES) {
      return {
        files: currentFiles,
        error: `${file.name || "file"} exceeds 10MB limit`,
      };
    }

    deduped.set(fileKey(file), file);
  }

  const files = Array.from(deduped.values());
  if (files.length > MAX_ATTACHMENTS) {
    return {
      files: currentFiles,
      error: `Maximum ${MAX_ATTACHMENTS} attachments per message`,
    };
  }

  return { files, error: null };
}

export function formatAttachmentSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
